const LeverApllyForm = {
  init() {
    LeverApllyForm.events();
    LeverApllyForm.fileInput();
  },

  events() {
    jQuery('.lever-apply-form').on('submit', function () {
      jQuery('.lever-apply-form-message').show();
      jQuery(this).addClass('loading');
    });
  },

  fileInput() {
    jQuery('#resume').on('change', function (e) {
      if (
        e.target.files.length &&
        e.target.files[0] &&
        e.target.files[0].name
      ) {
        // console.log(e.target.files[0]);

        var fileNameWrapper = jQuery('.filename-expo-wrapper');
        fileNameWrapper.addClass('uploaded-file');

        var fileName = e.target.files[0].name;
        jQuery('.filename-expo').text(fileName);

        var resumeInput = jQuery('.lever-form-resume-btn');
        resumeInput
          .addClass('uploaded-file')
          .find('.lever-form-resume-text')
          .text('File attached');
      } else {
        jQuery('.filename-expo').text('');

        var resumeInput = jQuery('.lever-form-resume-btn');
        resumeInput
          .removeClass('uploaded-file')
          .find('.lever-form-resume-text')
          .text('Attach resume / CV');

        var fileNameWrapper = jQuery('.filename-expo-wrapper');
        fileNameWrapper.removeClass('uploaded-file');
      }
    });

    jQuery('.lever-delete-icon').on('click', function () {
      jQuery('#resume').val('').trigger('change');
    });
  },
};

LeverApllyForm.init();
